import React from "react";
import { makeStyles } from "@material-ui/core";

const getCopyrightYear = () => new Date().getFullYear() >= 2024 ? new Date().getFullYear() : 2024;

const useStyles = makeStyles((theme) => ({
    root: {
        padding: "6px",
        textAlign: "center",
        fontSize: "11px",
        color: theme.palette.text.disabled,
        letterSpacing: "0.02em",
    },
}));

export const Copyright = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            © 2021–{getCopyrightYear()} Paznic, LLC &nbsp;·&nbsp; Pat. Nos. 11,282,317 &amp; 11,580,805
        </div>
    );
};
